"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnomalySearch = exports.AnomalyTypes = void 0;
const useQuery_1 = require("../../hooks/useQuery");
const contexts_1 = require("../../contexts");
const paths_1 = require("../../paths");
const fetchClient_1 = require("../../client/fetchClient");
const utils_1 = require("../../utils");
var AnomalyTypes;
(function (AnomalyTypes) {
    AnomalyTypes["MISSED_PUNCH"] = "MISSED_PUNCH";
    AnomalyTypes["DUPLICATE_PUNCH"] = "DUPLICATE_PUNCH";
})(AnomalyTypes = exports.AnomalyTypes || (exports.AnomalyTypes = {}));
function useAnomalySearch({ employeeId, startDate, endDate, anomalyTypes, shouldFetch, usageLocation }) {
    const { host, clientName, currentStage } = (0, contexts_1.useTaaConfigsContext)();
    const ApiPath = (0, paths_1.ANOMALY_SEARCH_API)(employeeId, startDate, endDate, anomalyTypes.toString(), 'OPEN');
    return (0, useQuery_1.useQueryWrapper)(['anomalySearch', ApiPath], () => (0, fetchClient_1.getData)({
        path: ApiPath,
        host,
        eventName: utils_1.taaEvents.GET_ANOMALY_SEARCH,
        metaData: {
            apiName: 'getAnomalySearch',
            clientName
        },
        usageLocation
    }, currentStage), {
        enabled: shouldFetch,
        staleTime: 60 * 1000,
        retry: false
    });
}
exports.useAnomalySearch = useAnomalySearch;
